module.exports = ".limit-message {\r\n    text-align: center;\r\n    max-width: 80%;\r\n    margin: 0 auto;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/limit/limit.component.css
// module id = ./src/app/components/limit/limit.component.css
// module chunks = main